import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LoginPage.module.css';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch('/.netlify/functions/send-magic-link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) throw new Error('Request failed');

      navigate('/members/check-email', { state: { email } });
    } catch {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <img
          src="/assets/images/logo.png"
          alt="B2B"
          className={styles.logo}
        />
        <h1 className={styles.title}>Member Access</h1>
        <p className={styles.subtitle}>
          Enter your email to receive your access link
        </p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <input
            type="email"
            required
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={styles.input}
            disabled={loading}
          />
          <button
            type="submit"
            className={styles.button}
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send link'}
          </button>
        </form>

        {error && <p className={styles.error}>{error}</p>}

        <a href="/" className={styles.backLink}>
          Back to site
        </a>
        <p className={styles.footnote}>
          Access reserved for B2B members.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
